import styled from '@emotion/styled';

export const ForgotPasswordButton = styled.button`
  background: none;
  font: var(--font-link-s);
  color: var(--color-black);
  align-self: flex-end;
  text-decoration: underline;
  cursor: pointer;
  border: none;
`;
